import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyComponent } from '../../../../models/SurveyTemplates';
import { Namespace } from '../../../../locales/translations';

interface TextInputFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const TextInputField: React.FC<TextInputFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.SURVEY_BUILDER]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event.target.value);
    };

    return (
        <TextField
            fullWidth
            value={value}
            onChange={handleChange}
            placeholder={field.placeholder || t('field_messages.text_input.enter_placeholder', { label: field.label.toLowerCase() }) as string}
            disabled={disabled}
            helperText={field.description}
        />
    );
};

export default TextInputField;
